export const snakeToCamelCase = (str: string) => str.split("_").join(" ");
